import { useLocation } from 'react-router-dom';

import { log } from '@/utils/functions/logger/logger';

/**
 * TODO: temporaire
 * Extracts the encrypted_data from the JWT token payload.
 * @param token - The JWT token.
 */
const getEncryptedDataFromToken = (token: string): string | null => {
  try {
    const payloadBase64 = token.split('.')[1];
    if (!payloadBase64) return null;

    const payload: { encrypted_data?: string } = JSON.parse(atob(payloadBase64));
    return payload.encrypted_data ?? null;
  } catch (error) {
    log.error('Failed to decode token payload', error);
    return null;
  }
};

export const useNavigationToKYC = () => {
  const location = useLocation();
  const path = location.pathname;
  const redirect = encodeURIComponent(path.slice(1));
  const token = sessionStorage.getItem('authToken');

  // TODO: On récupére le payload du jwt user temporairement, le temps que le kyc soit mis en place pour récupérer l'encrypted_data directement dans le token de session
  const encodedToken = token ? btoa(encodeURIComponent(getEncryptedDataFromToken(token) ?? '')) : null;
  const kycWebUrl = encodedToken
    ? `${import.meta.env.VITE_KYC_FUNNEL_URL}/sso/${encodedToken}?origin=web&redirect=${redirect}`
    : null;

  const navigateToKYC = (): void => {
    if (kycWebUrl) {
      window.open(kycWebUrl, '_self');
    } else {
      log.error('KYC URL is not available');
    }
  };

  return { navigateToKYC };
};
